(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fc-variant-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fc-variant-offers')) {
    let offerRequest = null;
    const loadOffers = () => {
      if (offerRequest) return offerRequest;
      offerRequest = fetch('https://image.footcourt-eg.com/public/variant-offers', {signal:AbortSignal.timeout(15000), credentials:'omit', cache:'no-store'})
        .then(response => { if (!response.ok) throw new Error('Offers unavailable'); return response.json(); })
        .then(data => { if (data.schema !== 1 || !Array.isArray(data.offers) || !(data.expiresAt > Date.now())) throw new Error('Offer data expired'); return data; })
        .finally(() => { offerRequest = null; });
      return offerRequest;
    };
    customElements.define('fc-variant-offers', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.config = JSON.parse(this.querySelector('[data-variant-offer-config]').textContent);
        this.host = this.closest('.hdt-product__variant-picker');
        if (!this.host) return;
        this.offers = [];
        const on = (target, type, handler) => target.addEventListener(type, handler, {signal:this.events.signal});
        on(this.host, 'change', () => this.queueRender());
        on(this.host, 'click', event => { if (event.target.closest('[role=option]')) this.queueRender(); });
        on(document, 'variant:selected', () => this.queueRender());
        on(document, 'variant:update', () => this.queueRender());
        on(document, 'visibilitychange', () => { if (!document.hidden) this.refresh(); });
        this.observer = new MutationObserver(() => this.queueRender());
        this.observer.observe(this.host, {childList:true, subtree:true, attributes:true, attributeFilter:['selected-variant','aria-selected']});
        this.refresh();
        this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 30000);
      }
      disconnectedCallback() {
        this.events?.abort(); this.events = null; this.observer?.disconnect();
        clearInterval(this.timer); clearTimeout(this.expiryTimer); cancelAnimationFrame(this.renderFrame);
        this.clearBadges();
      }
      async refresh() {
        if (this.pending) return;
        this.pending = true;
        try {
          const data = await loadOffers();
          if (!this.isConnected) return;
          const collections = new Set(this.config.collectionIds.map(String));
          this.offers = data.offers.filter(offer => collections.has(String(offer.collectionId)) && Array.isArray(offer.variantIds) && (!offer.endsAt || Date.parse(offer.endsAt) > Date.now()));
          clearTimeout(this.expiryTimer);
          const end = Math.min(data.expiresAt, ...this.offers.filter(o => o.endsAt).map(o => Date.parse(o.endsAt)));
          this.expiryTimer = setTimeout(() => { this.offers = []; this.render(); if (!document.hidden) this.refresh(); }, Math.max(0, end - Date.now()));
        } catch {
          this.offers = [];
        } finally {
          this.pending = false;
          if (this.isConnected) this.render();
        }
      }
      queueRender() {
        cancelAnimationFrame(this.renderFrame);
        this.renderFrame = requestAnimationFrame(() => { if (this.isConnected) this.render(); });
      }
      clearBadges() {
        this.host?.querySelectorAll('.fc-variant-offer-size').forEach(label => { label.classList.remove('fc-variant-offer-size'); label.removeAttribute('data-fc-offer-badge'); });
        this.host?.querySelectorAll('[data-fc-offer-label]').forEach(input => {
          const original = input.dataset.fcOfferLabel;
          if (original) input.setAttribute('aria-label', original); else input.removeAttribute('aria-label');
          delete input.dataset.fcOfferLabel;
        });
      }
      render() {
        const picker = this.host?.querySelector('hdt-variant-picker');
        if (!picker) { this.hidden = true; return; }
        const fields = [...picker.querySelectorAll('fieldset[data-index]')];
        const selected = [];
        fields.forEach(field => {
          const input = field.querySelector('input[is-value]:checked,input[is-value][type=hidden]');
          const option = field.querySelector('[role=option][aria-selected=true]');
          selected[Number(field.dataset.index)] = input?.value || option?.getAttribute('value') || null;
        });
        const sizeIndex = this.config.sizeIndex;
        const choices = this.offers.filter(offer => !offer.endsAt || Date.parse(offer.endsAt) > Date.now()).map(offer => {
          const ids = new Set(offer.variantIds.map(String));
          return {...offer, variants:this.config.variants.filter(variant => variant.available && ids.has(variant.id) && variant.options.every((value,index) => index === sizeIndex || !selected[index] || value === selected[index]))};
        }).filter(offer => offer.variants.length);
        const current = this.config.variants.find(variant => variant.options.every((value,index) => value === selected[index]));
        const chosen = choices.find(offer => offer.variants.some(variant => variant.id === current?.id)) || choices[0];
        const sizes = new Set(choices.flatMap(offer => offer.variants.map(variant => variant.options[sizeIndex])));
        const sizeField = fields.find(field => Number(field.dataset.index) === sizeIndex);
        if (!chosen || !sizeField) { this.hidden = true; this.clearBadges(); return; }
        sizeField.querySelectorAll('input[is-value][type=radio],button[role=option]').forEach(input => {
          const value = input.value || input.getAttribute('value');
          const label = input.matches('button') ? input : sizeField.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          if (!label) return;
          if (sizes.has(value)) {
            label.classList.add('fc-variant-offer-size'); label.dataset.fcOfferBadge = this.config.copy.badge;
            if (!input.hasAttribute('data-fc-offer-label')) input.dataset.fcOfferLabel = input.getAttribute('aria-label') || '';
            input.setAttribute('aria-label', value + ' — ' + this.config.copy.badge);
          } else {
            label.classList.remove('fc-variant-offer-size'); label.removeAttribute('data-fc-offer-badge');
            if (input.hasAttribute('data-fc-offer-label')) {
              if (input.dataset.fcOfferLabel) input.setAttribute('aria-label', input.dataset.fcOfferLabel); else input.removeAttribute('aria-label');
              delete input.dataset.fcOfferLabel;
            }
          }
        });
        const setText = (selector,text) => { const element = this.querySelector(selector); if (element.textContent !== text) element.textContent = text; };
        setText('.fc-variant-offer-sizes', this.config.copy.sizes.replace('__sizes__', [...sizes].join(' · ')));
        const qualifies = chosen.variants.some(variant => variant.id === current?.id);
        setText('.fc-variant-offer-status', qualifies ? this.config.copy.selected : this.config.copy.choose);
        this.dataset.selectedEligible = String(qualifies);
        this.querySelector('.fc-variant-offer-link').href = this.config.root.replace(/\/?$/, '/') + 'collections/' + encodeURIComponent(chosen.collectionHandle);
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
